import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ml-5 mr-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "SHISHAS", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExpansionPanel = _resolveComponent("ExpansionPanel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_v_expansion_panels, null, {
      default: _withCtx(() => [
        _createVNode(_component_ExpansionPanel, {
          title: "Orientalisch",
          price: 18,
          products: _ctx.oriental
        }, null, 8, ["products"]),
        _createVNode(_component_ExpansionPanel, {
          title: "Modern",
          price: 18,
          products: _ctx.modern
        }, null, 8, ["products"])
      ]),
      _: 1
    })
  ]))
}